"use client";

import { useEffect } from "react";
import logger from "@/lib/logger.mjs";

export default function ErrorLogger() {
  useEffect(() => {
    const handleError = (event) => {
      event.preventDefault();

      const error = event.error || event.reason;
      const mockReq = {
        url: window.location.pathname,
        method: "GET",
        headers: {
          "user-agent": window.navigator.userAgent,
          host: window.location.host,
          "x-forwarded-for": "",
        },
      };

      logger.error(error, mockReq);
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleError);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleError);
    };
  }, []);

  return null;
}
